import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { GameStateServiceService } from '../../world/GameStateService.service';
import { ScoreService } from '../../world/score.service';
import { WorldService } from '../word-controller/world.service';

@Component({
    selector: 'app-wasted-overlay',
    templateUrl: './wasted-overlay.component.html',
    styleUrls: ['./wasted-overlay.component.css']
})
export class WastedOverlayComponent implements OnInit, OnDestroy {
    isVisible = false;
    score = 0;

    @ViewChild('playAgainBtn') playAgainBtn: ElementRef<HTMLButtonElement>;

    private destroy$ = new Subject<void>();

    constructor(
        private gameStateService: GameStateServiceService,
        private scoreService: ScoreService,
        private worldService: WorldService
    ) {}

    ngOnInit(): void {
        this.gameStateService.playerDied$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.scoreService.bankedScore$.pipe(take(1)).subscribe(s => this.score = s);
                setTimeout(() => {
                    this.isVisible = true;
                    setTimeout(() => this.playAgainBtn?.nativeElement?.focus(), 0);
                }, 1500);
            });
    }

    onPlayAgain(): void {
        this.isVisible = false;
        this.worldService.restartGame();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
